package core.localStorage

import kotlinx.browser.localStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.w3c.dom.get
import org.w3c.dom.set
import kotlin.reflect.KProperty

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 14.10.22
 * Author : mariorosshirt
 */
class LocalStorageListDelegate(var mLocalStorageKey: String) {

    inline operator fun <reified T> getValue(thisRef: Any?, property: KProperty<*>): List<T> {
        return localStorage[mLocalStorageKey].let { Json.decodeFromString(it ?: "[]") }
    }

    inline operator fun <reified T> setValue(
        thisRef: Any?,
        property: KProperty<*>,
        value: List<T>
    ) {
        localStorage[mLocalStorageKey] = Json.encodeToString(value)
    }


    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------


    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}

class LocalStorageObjectDelegate(var mLocalStorageKey: String) {

    inline operator fun <reified T> getValue(thisRef: Any?, property: KProperty<*>): T? {
        return localStorage[mLocalStorageKey].let { Json.decodeFromString(it ?: "null") }
    }

    inline operator fun <reified T> setValue(
        thisRef: Any?,
        property: KProperty<*>,
        value: T?
    ) {
        localStorage[mLocalStorageKey] = Json.encodeToString(value)
    }


    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------


    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}
